import angular from 'angular';
import dashboardModule from './dashboard/dashboard';
import detailZoneModule from './detail-zone/detail-zone';
import detailedPaymentModule from './detailed-payment/detailed-payment';
import response from './response/response';
import myPayments from './my-payments/my-payments';

let payZoneModule = angular.module('app.payZone',[
  response.name,
  myPayments.name,
  dashboardModule.name,
  detailedPaymentModule.name,
  detailZoneModule.name
]);

export default payZoneModule;



/** WEBPACK FOOTER **
 ** ./www/components/pay-zone/pay-zone.js
 **/